import { IMenuData } from "@multiweb/types/contracts";
import { RequestContextWithoutTransactionContextId } from "../../../RequestContextWithoutTransactionContextId";

/**
 * Klient poskytující přístup k datům pro hlavní menu s volitelnou filtrací položek na základě aktivních rolí uživatele.
 * @includeToDoc
 */
export interface IMenuClient {
    /**
     * Získá datovou definici strukutry a položek hlavního menu aplikace na základě aktivních rolí uživatele.
     * Pokud jsou aktivní role uživatele zadány, vrátí položky, na které má uživatel právo. Pokud nejsou, vrací všechny položky menu.
     *
     * @param requestContext Viz {@link RequestContextWithoutTransactionContextId}
     */
    getMenuItems(requestContext?: RequestContextWithoutTransactionContextId): Promise<IMenuData>;
}
